// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Do More and Boost Your Odds!`
};

const de_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Mach mehr und erhöhe deine Gewinnchancen!`
};

const es_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `¡Haz más y aumenta tus posibilidades!`
};

const fr_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Faites Plus et Augmentez Vos Chances!`
};

const fi_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `mitä enemmän arpoja, sitä paremmat mahdollisuudet voittaa!`
};

const hi_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `और करें और अपने चांसेस बढ़ाएं!`
};

const ja_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `さらに参加してチャンスを高めよう！`
};

const nl_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Doe meer en verhoog je kansen!`
};

const pt_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Faça Mais e Aumente as Suas Chances!`
};

const ro_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Fiecare Punct înseamnă o șansă de câștig în plus!`
};

const th_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `ทำมากขึ้นและเพิ่มโอกาสของคุณ!`
};

const ur_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `مزید کریں اور اپنی جیتنے کے امکانات بڑھائیں!`
};

const zh_hant1_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `做得更多，提高您的中獎機會！`
};

const da_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Gør mere og boost dine chancer!`
};

const it_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Fai di più e aumenta le tue possibilità!`
};

const vn_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Làm nhiều hơn và tăng cơ hội của bạn!`
};

const ko_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `더 많이 참여하고 당첨 확률을 높이세요!`
};

const tr_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Daha fazla yapın ve şansınızı artırın!`
};

const lv_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Dariet vairāk un palieliniet savas izredzes!`
};

const ar_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `افعل المزيد وعزز فرصك!`
};

const bs_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Uradite više i povećajte svoje šanse!`
};

const sl_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Naredite več in povečajte svoje možnosti!`
};

const id_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Lakukan Lebih Banyak dan Tingkatkan Peluang Anda!`
};

const sv_widget_do_more_and_boost_odds = /** @type {(inputs: {}) => string} */ () => {
	return `Gör mer och öka dina chanser!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_do_more_and_boost_odds = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_do_more_and_boost_odds(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_do_more_and_boost_odds", locale)
	if (locale === "en") return en_widget_do_more_and_boost_odds(inputs)
	if (locale === "de") return de_widget_do_more_and_boost_odds(inputs)
	if (locale === "es") return es_widget_do_more_and_boost_odds(inputs)
	if (locale === "fr") return fr_widget_do_more_and_boost_odds(inputs)
	if (locale === "fi") return fi_widget_do_more_and_boost_odds(inputs)
	if (locale === "hi") return hi_widget_do_more_and_boost_odds(inputs)
	if (locale === "ja") return ja_widget_do_more_and_boost_odds(inputs)
	if (locale === "nl") return nl_widget_do_more_and_boost_odds(inputs)
	if (locale === "pt") return pt_widget_do_more_and_boost_odds(inputs)
	if (locale === "ro") return ro_widget_do_more_and_boost_odds(inputs)
	if (locale === "th") return th_widget_do_more_and_boost_odds(inputs)
	if (locale === "ur") return ur_widget_do_more_and_boost_odds(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_do_more_and_boost_odds(inputs)
	if (locale === "da") return da_widget_do_more_and_boost_odds(inputs)
	if (locale === "it") return it_widget_do_more_and_boost_odds(inputs)
	if (locale === "vn") return vn_widget_do_more_and_boost_odds(inputs)
	if (locale === "ko") return ko_widget_do_more_and_boost_odds(inputs)
	if (locale === "tr") return tr_widget_do_more_and_boost_odds(inputs)
	if (locale === "lv") return lv_widget_do_more_and_boost_odds(inputs)
	if (locale === "ar") return ar_widget_do_more_and_boost_odds(inputs)
	if (locale === "bs") return bs_widget_do_more_and_boost_odds(inputs)
	if (locale === "sl") return sl_widget_do_more_and_boost_odds(inputs)
	if (locale === "id") return id_widget_do_more_and_boost_odds(inputs)
	if (locale === "sv") return sv_widget_do_more_and_boost_odds(inputs)
	return "widget_do_more_and_boost_odds"
};